import React from 'react'
import {  Button, CircularProgress , Box, TextField } from '@material-ui/core'
import AddIcon from '@mui/icons-material/Add'
import { DataGrid } from '@mui/x-data-grid'
import DeleteIcon from '@mui/icons-material/Delete'
import NewTopicEditor from './component/NewTopicEditor'
import Snack from '../Snack'

const api = require('../api/api')

export default class TopicEditorTab extends React.Component {
	constructor(props) {
		super(props)
		
		this.state = {
			data: [],
			selectedRows: [],
			loading: false,
			errors: {},
			searchValue: ''
		}

		this.topicEditor = React.createRef()
	}

	setupGrid() {
		this.topicTypes = [ 'general' ]

		for (let row of this.state.data)  {
			let type = row.name

			if (this.topicTypes.indexOf(type) == -1) {
				this.topicTypes.push(type)
			}
		}

		this.columns = [
			{ field: 'id', headerName: 'ID', width: 90, type: 'number', editable: true },
		
			{ 
				field: 'name', 
				headerName: 'Name', 
				width: 150, 
				editable: true
			},
		
			{ field: 'questionLocked', headerName: 'Question Locked', type: 'boolean', width: 150, editable: true },
			
			{ 
				field: 'type', 
				headerName: 'Parent Topic', 
				width: 200, 
				editable: true,
				type: 'singleSelect',
				valueOptions: this.topicTypes
			},
		
			{
				field: 'lockedBy', 
				headerName: 'Locked By', 
				width: 200, 
				editable: true,
				type: 'number'
			},

			{ field: 'disabled', headerName: 'Disabled', type: 'boolean', width: 150, editable: true },
		]
	}

	componentDidMount() {
		api.topics.list().then(res => {
			this.setState({
				loading: false,
				data: res.topics
			}, () => {
				this.setupGrid()
				this.forceUpdate()
			})
		}).catch(err => {
			this.setState({
				error: err,
				loading: false
			})

			console.error(err)
		})
  }

	onClose(added) {
		if (added) {
			const data = this.topicEditor.current.getData()

			api.topics.insert(data).then(result => {
				let d = this.state.data

				d = d.slice(0)	
				data.id = result.topic.id

				d.push(data)

				this.setState({ 
					loading: false, 
					data: d
				})

				this.setupGrid()
			}).catch(err => {
				this.setState({
					error: err,
					loading: false
				})

				console.error(err)
			})
		} else {
			this.setState({
				loading: false
			})
		}
	}

	updateSearchValue(e) {
		this.setState({
			searchValue: e.target.value
		})
	}

	render() {
		if (!this.columns) {
			return this.renderProgressBar()
		}

		let search = this.state.searchValue.length > 0
		let data = []

		let searchValue = this.state.searchValue.toLowerCase()

		for (let row of this.state.data) {
			if (row.name && (!search || row.name.toLowerCase().indexOf(searchValue) != -1 || row.id.toString().indexOf(searchValue) != -1)) {
				data.push(row)
			}
		}

		return <Box sx={{ position: 'relative' }}>
			{ this.state.loading && this.renderProgressBar() }

			<div style={{ height: 720, width: '100%' }}>
				<Button disabled={this.state.loading} variant="contained" color="primary" aria-label="add" onClick={this.handleAdd.bind(this)} style={{ marginRight: '15px', marginBottom: '15px' }}>
					<AddIcon />
				</Button>

				<Button disabled={this.state.loading || this.state.selectedRows.length == 0} variant="contained" size="medium" color="secondary" aria-label="delete" style={{ marginRight: '15px', marginBottom: '15px' }} onClick={this.handleDelete.bind(this)}>
					<DeleteIcon />
				</Button>

				<TextField value={this.state.searchValue} onChange={this.updateSearchValue.bind(this)} label="Search" style={{ marginTop: '-15px', marginBottom: '15px' }} />

				<DataGrid
					className={this.state.loading ? 'disabledGrid' : 'regularGrid'}
					rows={data}
					columns={this.columns}
					pageSize={10}
					rowsPerPageOptions={[10]}
					checkboxSelection
					onCellEditCommit={this.handleGridChange.bind(this)}
					onSelectionModelChange={this.handleCheckboxChange.bind(this)}
					styles={{ height: 'calc(100% - 50px) !important' }}
				/>
			</div>

			<NewTopicEditor ref={this.topicEditor} onClose={this.onClose.bind(this)}/>
		</Box>
	}

	renderProgressBar() {
		return <CircularProgress size={48} className='loadingBar' />
	}

	handleGridChange(data) {
		let request = { id: data.id }
		request[data.field] = data.value

		api.topics.update(request).catch(error => console.error(error))
	}

	handleCheckboxChange(rows) {
		this.setState({
			selectedRows: rows
		})
	}
	
	handleDelete() {
		const rows = this.state.selectedRows

		if (rows.length == 0) {
			return
		}

		let data = this.state.data.slice(0) // Make a copy of a readonly array

		for (let i = data.length - 1; i >= 0; i--) {
			if (rows.indexOf(data[i].id) != -1) {
				data.splice(i, 1)
			}
		}

		this.setState({
			data: data,
			loading: true
		})

		this.setupGrid()

		api.topics.remove({
			id: rows
		}).catch(error => {
			Snack.instance.show(error)
			console.error(error)
		}).finally(() => {
			this.setState({ loading: false })
		})
	}

	handleAdd() {
		this.setState({ loading: true })
		this.topicEditor.current.open(this.topicTypes)
	}
}